import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const CatalogHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        {
          label: 'Catalogues',
          screenName: 'CatalogScreen',
          permissions: ['dashboard::catalogs.read'],
        },
        {
          label: 'Historique des publications',
          screenName: 'CatalogSnapshotScreen',
          permissions: ['dashboard::catalog-snapshots.read'],
        },
        {
          label: 'Prix du restaurant',
          screenName: 'CatalogShopScreen',
          permissions: ['dashboard::catalog-snapshot-to-shops.read'],
        },
        {
          label: 'Connecteurs',
          screenName: 'ConnectorScreen',
          permissions: ['dashboard::connectors.read'],
        },
      ]}>
      {children}
    </MainLayoutHeader>
  );
};
